import * as ActionTypes from '../BettingMode';

export function toggleOneClickMode(data) {
    return {type: ActionTypes.TOGGLE_ONE_CLICK_MODE, data};
}

export function setOneClickAmount(data) {
    return {type: ActionTypes.SET_ONE_CLICK_AMOUNT, data};
}

export function setAcceptFactorChangeMode(data) {
    return {type: ActionTypes.SET_ACCEPT_FACTOR_CHANGE_MODE, data};
}

export function toggleAcceptFactorIncrease(data) {
    return {type: ActionTypes.TOGGLE_ACCEPT_FACTOR_INCREASE, data};
}

export function toggleAcceptFactorDecrease(data) {
    return {type: ActionTypes.TOGGLE_ACCEPT_FACTOR_DECREASE, data};
}

export function setFavouriteBetAmount(data) {
    return {type: ActionTypes.SET_FAVOURITE_BET_AMOUNT, data};
}



// WEBPACK FOOTER //
// ./js/actions/creators/BettingMode.js